// extracted by mini-css-extract-plugin
export default {"loader":"load_loader__JDRSC","boxLoad1":"load_boxLoad1__Z39aw","brighten":"load_brighten__aPJ74","boxLoad2":"load_boxLoad2__CoNRb","boxLoad3":"load_boxLoad3__rj-5f"};